export default __webpack_public_path__ + "static/media/Dudas-orange.1b976eac.svg";